var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.container},[_c('p',{class:_vm.$style.title},[_vm._v("域名"),_c('span',{staticStyle:{"color":"#01cbf3"}},[_vm._v("优惠购")])]),_c('p',{class:_vm.$style.desc},[_vm._v(" 数量有限，先到先得。更多域名优惠请联系售前或渠道经理确认 ")])])}
var staticRenderFns = []

export { render, staticRenderFns }